import { CloseCircleFilled } from '@ant-design/icons'
import Map from '@common/Map'
import Upload from '@common/Upload'
import { HeaderView } from '@merchant-backend/common-components'
import { formatAreaCascader, isSiDaProperty } from '@merchant-backend/util'
import cls from 'classnames'
import { Button, Cascader, MagicInput, Select } from 'hljd'
import { toJS } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import Example from './Example'
import exampleStore from './Example/store'
import MapView from './MapView'
import mapStore from './MapView/store'
import Store from './store'
import styles from './style.module.less'

const Option = Select.Option

let imgFilters = {
  mime_types: [{ title: 'Image files', extensions: 'jpg,png,jpeg,bmp' }]
}

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }

  componentDidMount() {
    const { fromCreat } = this.props

    this.store.getStoreInfo(fromCreat)
    this.store.getCountry()
  }

  handleShowMap() {
    mapStore.showMap()
  }

  //针对首次加载数据，获取经纬度慢于地图加载，600毫秒后再次进行获取
  getMap = (map, marker) => {
    this.store.map = map
    this.store.marker = marker
    map.setStatus({ dragEnable: false, zoomEnable: false }) //禁止地图缩放和拖动
    let lon = this.store.longitude
    let lat = this.store.latitude
    if (lon && lat) {
      marker.setMap(map)
      map.setCenter([lon, lat])
      marker.setPosition([lon, lat])
    } else {
      marker.setMap(map)
      map.setCenter()
    }
    setTimeout(() => {
      let lon = this.store.longitude
      let lat = this.store.latitude
      marker.setMap(map)
      map.setCenter([lon, lat])
      marker.setPosition([lon, lat])
    }, 1000)
  }

  //获取地址
  getLocation = (options, values) => {
    let provice = options.find(item => item.value == values[0]) || {}
    let city = provice.children || []
    let area = city.find(item => item.value == values[1]) || {}
    return area.children || []
  }

  render() {
    const { indexStore, fromCreat } = this.props

    const {
      status,
      reason,
      name,
      contact_mobile,
      shop_phone,
      shop_area,
      shop_area_chinese,
      areas,
      address,
      country,
      logo_path_square,
      loading,
      examine,
      latitude,
      des,
      cover_path,
      property_id
    } = this.store

    let options = formatAreaCascader(country)

    let style = { marginLeft: 250 }

    return (
      <HeaderView title={fromCreat ? '' : '店铺信息'}>
        <div
          className={cls({
            [styles.edit]: true,
            [styles.register_edit]: true
          })}
        >
          <MapView myStore={this.store} />

          {status == 1 &&
            reason && (
              <div className={styles.checkTip} style={{ marginTop: 50 }}>
                <p>
                  <CloseCircleFilled />&nbsp;店铺资料审核未通过
                </p>
                <p className={styles.reason}>原因：{reason}</p>
                <a
                  onClick={() =>
                    window.open(
                      '//www.hunliji.com/p/wedding/Public/wap/m/audit-rules/index.html',
                      '',
                      `height=667, width=375, top=${(window.screen.height -
                        667) /
                        2},left=${(window.screen.width - 375) / 2}`
                    )
                  }
                >
                  查看审核标准
                </a>
              </div>
            )}

          <div className={styles.item} style={{ ...style }}>
            <span className={styles.must} style={{ verticalAlign: 165 }}>
              团队LOGO
            </span>
            <Upload
              clipabled
              link={logo_path_square ? logo_path_square : ''}
              onOk={this.store.upload('logo_path_square')}
              onDelete={this.store.removeImg('logo_path_square')}
              target="_self"
              aspect={400 / 400}
              onCliped={this.store.clipPic('logo_path_square')}
              filters={imgFilters}
            />
            <p className={styles.txt}>
              logo图中不能包含营销信息、联系方式、微信、微博、网址二维码等
            </p>
            <p
              className={styles.txt}
              style={{ color: '#448AFC', marginTop: 5 }}
            >
              推荐尺寸400*400像素
            </p>
          </div>

          <div className={styles.item} style={{ ...style }}>
            <span className={styles.must}>团队名称</span>
            <MagicInput
              size="large"
              placeholder="请输入团队名称"
              style={{ width: 380 }}
              onChange={e => this.store.changeField('name')(e.target.value)}
              value={name}
              maxLength={20}
              countPosition="right"
              showCount
            />
            <p className={styles.txt}>
              支持中文、数字及括号，不支持符号表情和附加内容，不超过20个字
            </p>
          </div>

          <div className={styles.item} style={{ ...style }}>
            <span className={styles.must}>所在地区</span>
            {examine == 1 ? (
              <span style={{ color: 'rgba(0,0,0,.65)' }}>
                {shop_area_chinese.join(' / ')}
                <Select
                  style={{ width: 140 }}
                  value={String(areas)}
                  onChange={this.store.changeField('areas')}
                >
                  {this.getLocation(options, toJS(shop_area)).map(item => (
                    <Option value={String(item.key)} key={item.key}>
                      {item.label}
                    </Option>
                  ))}
                </Select>
              </span>
            ) : (
              <>
                <Cascader
                  style={{ width: 300 }}
                  options={options}
                  value={toJS(shop_area)}
                  onChange={this.store.changeField('shop_area')}
                  placeholder="请选择店铺所在地区"
                />
              </>
            )}
          </div>

          <div className={styles.item} style={{ ...style }}>
            <span className={styles.must}>详细地址</span>
            <MagicInput
              size="large"
              style={{ width: 460 }}
              placeholder="建议输入门店地址，便于用户找到"
              onChange={e => this.store.changeField('address')(e.target.value)}
              value={address}
              maxLength={30}
              countPosition="right"
              showCount
            />
            <p className={styles.txt} style={{ paddingBottom: 20 }}>
              为了让顾客了解您线下店铺的地址信息，<span>
                请务必在地图上标注、确认
              </span>
            </p>
            <div className={styles.mapBox} onClick={this.handleShowMap}>
              <p
                className={styles.mapTips}
                style={{ background: latitude ? '#2FC286' : '#508CEE' }}
              >
                {latitude ? (
                  <span>
                    <img
                      className={styles.mapImg}
                      src="//qnm.hunliji.com/o_1d8ft4rj2rvd1nmk6vq1lka15p19.png"
                      width={24}
                      height={24}
                    />
                    <span style={{ paddingLeft: 2 }}>
                      门店位置已标记，点击地图任意处修改
                    </span>
                  </span>
                ) : (
                  <span>
                    <img
                      className={styles.mapImg}
                      src="//qnm.hunliji.com/o_1d8ft531o126313jmahb7o6no1e.png"
                      width={24}
                      height={24}
                    />
                    <span style={{ paddingLeft: 2 }}>
                      点击地图任意处标记门店位置
                    </span>
                  </span>
                )}
              </p>
              <div style={{ height: 400 }}>
                <Map afterRender={this.getMap} />
              </div>
            </div>
          </div>

          <div className={styles.item} style={{ ...style }}>
            <span className={styles.must}>联系手机</span>
            <MagicInput
              size="large"
              style={{ width: 460 }}
              placeholder="用于接收婚礼纪平台业务提醒短信及电话"
              onChange={e =>
                this.store.changeField('contact_mobile')(e.target.value)
              }
              value={contact_mobile}
              maxLength={11}
              countPosition="right"
              showCount
            />
            <p className={styles.txt}>用于接收婚礼纪平台业务提醒短信及电话</p>
          </div>

          <div className={styles.item} style={{ ...style }}>
            <span className={styles.must}>客服电话</span>
            <MagicInput
              size="large"
              style={{ width: 460, marginRight: 20 }}
              placeholder="用于顾客咨询，请输入区号+座机号或者手机号（请勿附带“-”等符号）"
              value={shop_phone}
              onChange={e =>
                this.store.changeField('shop_phone')(e.target.value)
              }
              countPosition="right"
              showCount
            />
            <p className={styles.txt}>
              请填写用于门店接待的常用电话，建议填写座机
            </p>
          </div>

          {isSiDaProperty() && (
            <>
              <div className={styles.item} style={{ ...style }}>
                <span className={styles.must}>团队简介</span>
                <MagicInput.TextArea
                  rows={5}
                  style={{ width: 600 }}
                  placeholder="用一段话介绍您的商铺，会在您的商家主页显示"
                  onChange={e => this.store.changeField('des')(e.target.value)}
                  value={des}
                  maxLength={100}
                  countPosition="inner"
                  showCount
                />
                <p className={styles.txt}>
                  填写团队简介，注意不能出现网址、微信、手机号、支付信息等内容。
                </p>
                <p className={styles.txt}>
                  建议突出团队特色。<a
                    onClick={exampleStore.showExample(property_id)}
                  >
                    优秀商家简介举例
                  </a>
                </p>
              </div>

              <div className={styles.item} style={{ ...style }}>
                <span className={styles.must} style={{ verticalAlign: 165 }}>
                  团队封面
                </span>
                <Upload
                  clipabled
                  target="_self"
                  aspect={isSiDaProperty() ? 1080 / 748 : 1080 / 472}
                  onCliped={this.store.clipPic('cover_path')}
                  link={cover_path ? cover_path : ''}
                  onOk={this.store.upload('cover_path')}
                  onDelete={this.store.removeImg('cover_path')}
                  filters={imgFilters}
                />
                <p className={styles.txt}>
                  为APP端团队主页背景图，请上传与经营范围相关的高清图片，请不要包含极限词
                </p>
                <p
                  className={styles.txt}
                  style={{ color: '#448AFC', marginTop: 5 }}
                >
                  推荐尺寸为{isSiDaProperty() ? '1080*748' : '1080*472'}像素
                </p>
              </div>
            </>
          )}

          <div className={styles.center}>
            <Button
              type="primary"
              onClick={this.store.updateStoreInfo(indexStore)}
              className={styles.save}
              loading={loading}
            >
              {fromCreat ? '下一步' : '提交审核'}
            </Button>
          </div>

          <Example />
        </div>
      </HeaderView>
    )
  }
}
